import { WidgetConfigWithHideableToolbar } from 'widgets/WidgetToolbarShowHidePanel/WidgetConfigWithHideableToolbar';
import { ConfigStateWithGridSupport } from 'widgets/store/grid/reducer';
import { GridFiltersState } from 'widgets/store/grid/filters/FilterState';
import { SymbolEventColumn } from 'widgets/corpActions/widget/grid/columnDefinitions';
import { SortModel, SortDirection } from '@instinet-analytics/core-lib';
import { DockingConfig } from '@instinet-analytics/semantic-ui-components';
import { SymbolEventsTypeValue } from 'widgets/corpActions/api/SymbolEventsRequest';

export interface CorporateActionsWidgetConfigStateLegacy {
    caType?: SymbolEventsTypeValue;
}
export const isLegacyCorporateActionsWidgetConfig = (
    config?:
        | Partial<CorporateActionsWidgetConfigState>
        | Partial<CorporateActionsWidgetConfigStateLegacy>
): config is CorporateActionsWidgetConfigStateLegacy => {
    return !!(config as CorporateActionsWidgetConfigStateLegacy)?.caType;
};

export interface CorporateActionsWidgetConfigState
    extends WidgetConfigWithHideableToolbar,
        ConfigStateWithGridSupport<SymbolEventColumn>,
        GridFiltersState<SymbolEventColumn>,
        DockingConfig {
    caTypes: Array<SymbolEventsTypeValue>;
    excludeHistorical?: boolean;
    excludeUpcoming?: boolean;
    excludeToday?: boolean;
}

const initialSort: SortModel<SymbolEventColumn> = [
    { colId: 'effectiveDate', sort: SortDirection.DESCENDING },
    { colId: 'announcementDate', sort: SortDirection.DESCENDING },
    { colId: 'type', sort: SortDirection.ASCENDING },
];

export const initialCorporateActionsConfiguration: CorporateActionsWidgetConfigState =
    {
        excludeHistorical: true,
        columnWidths: {},
        visibleColumns: ['symbol', 'type', 'announcementDate', 'effectiveDate'],
        filters: [],
        sort: initialSort,
        dockPosition: 'Bottom',
        dockPercentage: 30,
        caTypes: [],
    };
